import React from "react";
import { NewTab, PageTab } from "../../../../components";
import Configure from "./VideoInterviewTabs/Configure";
import Overview from "./VideoInterviewTabs/Overview";

const VideoInterview = ({category, type, selectedModule}) => {
  const tabList = [
    {
      title: "Overview",
      page: <Overview category={category} type={type} selectedModule={selectedModule} />,
      type: "main",
      id: "marketplace_insights",
    },
    {
      title: "Configure",
      page: <Configure category={category} type={type} selectedModule={selectedModule} />,
      type: "main",
      //   id: "marketplace_accounts",
    },
  ];
  return (
    <div className="flex flex-1 ">
      {/* <div className="flex flex-col gap-3 p-4 border border-gray-100 rounded-lg shadow-sm bg-white mb-10">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-11 h-12 rounded-md border border-gray-100 bg-gray-50 text-lg font-semibold text-gray-700">
            Z
          </div>
          <div>
            <p className="text-lg font-medium text-gray-800">Zoom</p>
            <p className="text-sm text-gray-500">Video Interview</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-6 text-sm">
          <div>
            <span className="text-gray-500">Provider:</span>{" "}
            <span className="text-gray-800 font-medium">Zoom</span>
          </div>
          <div>
            <span className="text-gray-500">Website:</span>{" "}
            <a
              href="https://zoom.us"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              zoom.us
            </a>
          </div>
        </div>
      </div> */}

      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
      />
    </div>
  );
};

export default VideoInterview;
